import { GameManager } from "@/app/lib/game-state/game-manager";
import { GameMode, TSnapshot } from "@/app/lib/game-state/game-types";

export type Feedback = {
    gameName: GameMode;
    comments: string;
    type: string;
    snapshot: TSnapshot | string;
}

export function openFeedbackWindow(gameManager: GameManager) {
    const url = '/feedback';
    const name = 'feedback';
    const specs = 'width=500,height=350'

    let saveKey: string = '';
    // for pyramid games, the save key is the version
    if (gameManager.activeMode === 'pyramid') {
        saveKey = gameManager.pyramid.state.version;
    }
    // for story games, it's the levelID
    if (gameManager.activeMode === 'story') {
        saveKey = gameManager.story.state.levelID;
    }

    const feedbackWindow = window.open(`${url}?gameName=${gameManager.activeMode}&saveKey=${saveKey}`, name, specs);

    if (!feedbackWindow) {
        alert('Please allow pop-ups for this site to open the feedback form.')
    }
}